/* eslint-disable valid-jsdoc */
import React from 'react';
import { getListParsedState } from '../utils/getListParsedState';
/**
 * From the tree structure of list items we get meta information and
 * flatten list in right order without taking elements that hidden in expanded groups
 */
export function useListParsedState({ items, getId }) {
    const result = React.useMemo(() => {
        return getListParsedState(items, getId);
    }, [getId, items]);
    return result;
}
